import React from 'react';

import { Button } from 'components/Button';

import CustomModal from 'components/CustomModal';

import { FieldList, FieldItem } from './styles';

interface MissingFilesModalProps {
  open: boolean;
  onClose: () => void;
  missingFields: { key: string; title: string }[];
}

const MissingFilesModal: React.FC<MissingFilesModalProps> = ({ open, onClose, missingFields }): React.ReactElement => (
  <CustomModal
    openModal={open}
    onClose={onClose}
    modalTitle="Attachments need to be re-uploaded"
    modalDescription={`The following attachments were not found and need to be re-selected.
      This can happen if you refreshed the page or returned to a saved draft.`}
    submitButton={
      <Button id="missing-files-ok-button" onClick={onClose} variant="contained" size="large" fullWidth>
        OK
      </Button>
    }
  >
    <FieldList>
      {missingFields.map((field) => (
        <FieldItem key={field.key}>{field.title}</FieldItem>
      ))}
    </FieldList>
  </CustomModal>
);

export default MissingFilesModal;
